module.exports = __webpack_public_path__ + "img/venuetwo-jkzsdt-active.776a0531.png";